export const changeIUNameReducer = (state = "AlEdaidAlTwal", action) => {
    switch (action.type) {
      case "CHANGE_IU_NAME":
        return action.payload.iuName;
      default:
        return state;
    }
};